import Session from 'supertokens-web-js/recipe/session';
import GetEmail from 'src/services/GetSessionEmail'
import { AxiosResponse } from 'axios'

async function getuser() {
    let useremail: AxiosResponse<any, any>
    if (await Session.doesSessionExist()) {
        try {
          let userId  = await Session.getUserId();
          //let loggedname = accessTokenPayload.name;
         
          console.log("name is", userId);
              useremail   = await GetEmail(userId);
          return useremail.data[0];
        }
        catch (err: any) {
            window.alert(`user is not found`);
            console.log(err);
           }
    }
  
}
export default  getuser